import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import GameList from './components/GameList';
import Tournaments from './components/Tournaments';
import Leaderboards from './components/Leaderboards';
import Alerts from './components/Alerts';
import Privacy from './components/Privacy';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Membership from './components/Membership';
import ThemeToggle from './components/ThemeToggle';

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/games" element={<GameList />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/leaderboards" element={<Leaderboards />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/membership" element={<Membership />} />
            {/*<Route path="/contact" element={<Contact />} />*/}
          </Routes>
          {/* People look for a privacy link in the footer, so the policy is not
              only reachable from the tick-box on the alerts form. */}
          <footer className="site-footer">
            <Link to="/privacy">Privacy &amp; Text Message Terms</Link>
          </footer>
          <ThemeToggle />
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
